/**
 * @generated SignedSource<<ba72210b24b3575b04b474e9b14703b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type WeeklyPaceSkillSource = "DEMONSTRATED" | "DIRECTLY_PASSED" | "%future added value";
export type StudentSkillAssessmentWeeklySnapshotFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  reportFromDate: any;
  reportToDate: any;
  siteIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type DashboardGetWeeklySnapshotQuery$variables = {
  filter: StudentSkillAssessmentWeeklySnapshotFilterInput;
  source: WeeklyPaceSkillSource;
};
export type DashboardGetWeeklySnapshotQuery$data = {
  readonly studentsSkillAssessmentsWeeklySnapshot: ReadonlyArray<{
    readonly numberOfStudents: number;
    readonly uniqueSkillsPassed: number | null | undefined;
  }>;
};
export type DashboardGetWeeklySnapshotQuery = {
  response: DashboardGetWeeklySnapshotQuery$data;
  variables: DashboardGetWeeklySnapshotQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "source"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "source",
        "variableName": "source"
      }
    ],
    "concreteType": "StudentsSkillAssessmentsWeeklySnapshotReport",
    "kind": "LinkedField",
    "name": "studentsSkillAssessmentsWeeklySnapshot",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uniqueSkillsPassed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberOfStudents",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardGetWeeklySnapshotQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardGetWeeklySnapshotQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2fb3e4df911b2aa75d43eaa95540f22a",
    "id": null,
    "metadata": {},
    "name": "DashboardGetWeeklySnapshotQuery",
    "operationKind": "query",
    "text": "query DashboardGetWeeklySnapshotQuery(\n  $filter: StudentSkillAssessmentWeeklySnapshotFilterInput!\n  $source: WeeklyPaceSkillSource!\n) {\n  studentsSkillAssessmentsWeeklySnapshot(filter: $filter, source: $source) {\n    uniqueSkillsPassed\n    numberOfStudents\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ef8a07c80a671a529e52cdfbf00f01e";

export default node;
